export default "__VITE_ASSET__BbavR4s7__"